import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOperators } from './operators';

/**
 * Composable that provides assistant filtering context
 * @returns {{ filterTypes: import('vue').ComputedRef }}
 */
export function useAssistantFilterContext() {
  const { t } = useI18n();

  const {
    equalityOperators,
    containmentOperators,
    dateOperators,
    comparisonOperators,
  } = useOperators();

  /**
   * @type {import('vue').ComputedRef}
   */
  const filterTypes = computed(() => [
    {
      attributeKey: 'name',
      value: 'name',
      attributeName: t('PILOT.ASSISTANTS.FILTER.NAME'),
      label: t('PILOT.ASSISTANTS.FILTER.NAME'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'description',
      value: 'description',
      attributeName: t('PILOT.ASSISTANTS.FILTER.DESCRIPTION'),
      label: t('PILOT.ASSISTANTS.FILTER.DESCRIPTION'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'status',
      value: 'status',
      attributeName: t('PILOT.ASSISTANTS.FILTER.STATUS'),
      label: t('PILOT.ASSISTANTS.FILTER.STATUS'),
      inputType: 'searchSelect',
      options: [
        {
          id: 'draft',
          name: t('PILOT.ASSISTANTS.STATUS.DRAFT'),
        },
        {
          id: 'published',
          name: t('PILOT.ASSISTANTS.STATUS.PUBLISHED'),
        },
      ],
      dataType: 'text',
      filterOperators: equalityOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'knowledge_bases_count',
      value: 'knowledge_bases_count',
      attributeName: t('PILOT.ASSISTANTS.FILTER.KNOWLEDGE_BASES_COUNT'),
      label: t('PILOT.ASSISTANTS.FILTER.KNOWLEDGE_BASES_COUNT'),
      inputType: 'plainText',
      dataType: 'number',
      filterOperators: comparisonOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'created_at',
      value: 'created_at',
      attributeName: t('PILOT.ASSISTANTS.FILTER.CREATED_AT'),
      label: t('PILOT.ASSISTANTS.FILTER.CREATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'updated_at',
      value: 'updated_at',
      attributeName: t('PILOT.ASSISTANTS.FILTER.UPDATED_AT'),
      label: t('PILOT.ASSISTANTS.FILTER.UPDATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
  ]);

  return { filterTypes };
}
